export default __webpack_public_path__ + "static/media/Care01.851ff1f1.png";